import { render, staticRenderFns } from "./VehicleFields.vue?vue&type=template&id=df889436"
import script from "./VehicleFields.vue?vue&type=script&lang=js"
export * from "./VehicleFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports